import React from 'react';
import { useParams } from 'react-router-dom';
import { PushComponent, UiComponent } from 'components';
import { PushQuery } from 'queries';

/** 신규 작성(`/push/register`)과 수정(`/push/:id/edit`)을 함께 처리한다. */
function Register() {
  const { id } = useParams<{ id: string }>();
  const { data: push, isLoading } = PushQuery.useGet(id ?? '');

  // 수정 진입 시 기존 값이 준비되기 전에 폼을 그리면 빈 값으로 초기화된다.
  if (id && isLoading) return null;

  return (
    <>
      <UiComponent.PageTitle>
        {id ? '푸시 수정' : '푸시 작성'}
      </UiComponent.PageTitle>
      <PushComponent.Form push={push} />
    </>
  );
}

export default Register;
